// extracted by mini-css-extract-plugin
export default {"menu_item":"ToggleMenuItem_menu_item__jWucd","toggle_menu_item":"ToggleMenuItem_toggle_menu_item__bpvrV"};